import Component from '../../lib/component'

export default class FormValidatorComponent extends Component {
    static selector () {
        return '.form-validator'
    }

    constructor (opts) {
        super(opts)

        if (!this.getForm())
            return

        this.render()
        this.listen()
    }

    listen () {
        this.getForm()
            .addEventListener('valid', this.onFormValid.bind(this))

        this.getForm()
            .addEventListener('invalid', this.onFormInvalid.bind(this))

        this.getFormValidationEls()
            .forEach((el) => {
                el
                    .addEventListener('invalid', (e) => {
                        e.preventDefault()
                        e.stopPropagation()

                        if (this.el.classList.contains('dirty'))
                            this.onDirty(e)
                    })

                el
                    .addEventListener('focus',
                        this.onInputFocus.bind(this))

                el
                    .addEventListener('blur',
                        this.onDirty.bind(this))

                el
                    .addEventListener('change', (e) =>
                        el.classList.contains('dirty')
                            ? this.onDirty(e)
                            : null)

                el
                    .addEventListener('keyup', () =>
                        this.el.classList.contains('dirty')
                            ? this.onDirty()
                            : null)
            })

        this.getSubmitButtons()
            .forEach(el => el
                .addEventListener('focus', this.onDirty.bind(this)))

        this.getSubmitButtons()
            .forEach(el => el
                .addEventListener('click', this.onForceDirty.bind(this)))

        this.getForm()
            .addEventListener('submit', this.onSubmit.bind(this))
    }

    onInputFocus (e) {
        const controls = e.target.getAttribute('aria-controls')
            ? document.querySelector(`#${
                e.target.getAttribute('aria-controls')}`)
            : null

        if (!this.el.classList.contains('dirty'))
            this.el.classList.add('dirty')

        if (!controls || e.target.classList.contains('dirty'))
            return

        e.target.classList.add('focus-init')

        const onFocusInit = () => {
            if (controls === document.activeElement
                    || controls.contains(document.activeElement)
                    || e.target === document.activeElement)
                return

            document.removeEventListener('focusin', onFocusInit)
            e.target.classList.remove('focus-init')
            this.onDirty(e)
        }

        document
            .addEventListener('focusin', onFocusInit)
    }

    onFormValid (e) {
        if (this.el.classList.contains('invalid'))
            this.el.classList.remove('invalid')

        this.getSubmitButtons()
            .forEach(el => el.removeAttribute('disabled'))
    }

    onFormInvalid (e) {
        e.preventDefault()
        e.stopPropagation()

        if (this.getBrowser('name').match(/^(ie|edge)$/)
                || this.getForm() !== this.el)
            this.el.classList.add('invalid')

        this.getSubmitButtons()
            .forEach(el => {
                el.disabled = true
            })
    }

    onForceDirty () {
        this.getFormValidationEls()
            .forEach(el => {
                el.classList.add('dirty')

                const fieldset = this.getFieldsetFromEl(el)

                if (fieldset)
                    fieldset.classList.add('dirty')
            })

        this.onDirty()
    }

    onDirty (e) {
        this.el.classList.add('dirty')

        if (!this.isFormValid()
                && (this.getBrowser('name').match(/^(ie|edge)$/)
                    || this.getForm() !== this.el))
            this.el.classList.add('invalid')

        if (e && e.target) {
            e.target.classList.add('dirty')

            const fieldset = this.getFieldsetFromEl(e.target)

            if (fieldset)
                fieldset.classList.add('dirty')
        }

        this.renderValidationEls()

        this.getSubmitButtons()
            .forEach(el => {
                el.disabled = !this.isFormValid()
            })
    }

    onSubmit (e) {
        if (!this.el.classList.contains('dirty'))
            this.el.classList.add('dirty')

        let classListMethod

        if (!this.isFormValid()
                && !this.el.classList.contains('invalid')) {
            if (this.props.onsubmit)
                this.el.removeAttribute('data-onsubmit')

            e.preventDefault()
            classListMethod = 'add'
        }

        if (this.isFormValid()
                && this.el.classList.contains('invalid'))
            classListMethod = 'remove'

        if (classListMethod)
            this.el.classList[classListMethod]('invalid')

        if (this.props.onsubmit === 'true')
            return e.preventDefault()

        if (!this.props.onsubmit)
            this.props.onsubmit = true

        this.onForceDirty()
    }

    isFormValid () {
        return !this.getFormValidationEls()
            .some(el => {
                return !el.validity.valid
            })
    }

    getForm () {
        if (this.el.tagName === 'FORM')
            return this.el

        if (this.props.form)
            return document.querySelector(`#${this.props.form}`)

        return this.el.querySelector('form')
    }

    getFormEls () {
        return Array.from(this.el.querySelectorAll('input, textarea, select'))
    }

    getFormValidationEls () {
        return this.getFormEls()
            .filter(el => el.type !== 'hidden'
                && (el.pattern
                    || el.required))
    }

    getFieldsetFromEl (el) {
        let fieldset = null

        if (!el)
            return fieldset

        while (el !== this.el && el !== document.body) {
            if (!el.tagName.match(/fieldset/i)) {
                el = el.parentElement
                continue
            }

            fieldset = el
            break
        }

        return fieldset
    }

    getSubmitButtons () {
        return Array.from(this.el.querySelectorAll('[type="submit"]'))
    }

    renderValidationEls () {
        this.getFormValidationEls()
            .forEach(el => {
                const isValid = el.validity.valid

                el.classList[isValid ? 'remove' : 'add']('invalid')

                const invalidId = el
                    .getAttribute('data-form-validator-group-invalid')

                if (invalidId
                        && document.querySelector(`#${invalidId}`)) {
                    if (isValid
                            && el.getAttribute('aria-describedby')
                            && el.getAttribute('aria-describedby')
                                .match(invalidId)) {
                        const describedby = el.getAttribute('aria-describedby')
                            .replace(invalidId, '')
                            .trim()

                        if (!describedby)
                            el.removeAttribute('aria-describedby')

                        if (describedby)
                            el.setAttribute('aria-describedby', describedby)
                    }

                    if (!isValid
                            && el.classList.contains('dirty')
                            && (!el.getAttribute('aria-describedby')
                                || !el.getAttribute('aria-describedby')
                                    .match(invalidId)))
                        el.setAttribute('aria-describedby', `${
                            (el.getAttribute('aria-describedby') || '').trim()} ${
                            invalidId}`.trim())
                }

                const fieldset = this.getFieldsetFromEl(el)

                if (fieldset)
                    fieldset.classList[isValid ? 'remove' : 'add']('invalid')
            })
    }

    render () {
        Array.from(this.getFormEls())
            .filter(el => el.type !== 'hidden'
                && !el.type.match(/(radio|checkbox)/))
            .forEach((el) => {
                if ('autocapitalize' in el && el.type !== 'text')
                    el.setAttribute('autocapitalize', 'none')

                if ('autocomplete' in el && el.autocomplete !== 'off')
                    el.setAttribute('autocomplete', 'on')
            })
    }
}
